import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { NotFound } from '../../components';
import { STORE_ROUTER } from '../../constants';
import { RouterStore } from '../../stores';
import './style.css';

// tslint:disable-next-line no-any
export interface NotFoundPageProps extends RouteComponentProps<any> {
  /* [STORE_ROUTER]: RouterStore; */
}

export interface NotFoundPageState {
  /* empty*/
}

@inject(STORE_ROUTER)
@observer
export class NotFoundPage extends React.Component<
  NotFoundPageProps,
  NotFoundPageState
> {
  render() {
    const routerStore = this.props[STORE_ROUTER] as RouterStore;
    const path = routerStore.location
      ? routerStore.location.pathname
      : undefined;

    return <NotFound path={path} />;
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/app/containers/NotFoundPage/index.tsx